import PropTypes from 'prop-types';

export default function Radio({ name, value, callback, checked = false, testId = '' }) {
	return (
		<input
			type="radio"
			name={name}
			value={value}
			onChange={(e) => {
				callback(e.target.value, e.target.checked);
			}}
			checked={checked}
			data-testid={testId}
		/>
	);
}

Radio.propTypes = {
	callback: PropTypes.func.isRequired,
	checked: PropTypes.bool,
	name: PropTypes.string.isRequired,
	testId: PropTypes.string,
	value: PropTypes.string.isRequired,
};
